import * as React from 'react';
import { Button } from '@cian/ui-kit';

import { IconToggleHeartOn16, IconToggleHeartOff16 } from '@cian/ui-kit-design-tokens/icons';

interface IDumbFavoriteButtonProps {
  isFavorite: boolean;
  hideText?: boolean;

  onClick?(e: React.MouseEvent): void;
}

export const DumbFavoriteButton = ({ isFavorite, onClick, hideText = false }: IDumbFavoriteButtonProps) => {
  const buttonText = isFavorite ? 'В избранном' : 'В избранное';

  return (
    <Button
      data-mark={'DumbFavoriteButton'}
      theme={'fill_white_primary'}
      size={'XS'}
      onClick={onClick}
      beforeIcon={
        isFavorite ? (
          <IconToggleHeartOn16 color={'icon-negative-default'} data-testid="FavoriteButtonIconOn" />
        ) : (
          <IconToggleHeartOff16 color={'icon-negative-default'} data-testid="FavoriteButtonIconOff" />
        )
      }
    >
      {hideText ? '' : buttonText}
    </Button>
  );
};
